module.exports = __webpack_public_path__ + "static/media/GA_Post_2018.12.08-3.50a511e7.webp";